import * as marketingButtonStyles from '../../../styles/internal-page/marketing-button.module.scss';
import PropTypes from 'prop-types';

import {GatsbyImage, getImage} from 'gatsby-plugin-image';

import IconContainer from '../IconContainer';
import React from 'react';
import PolyLink from '../PolyLink';
import {altNN} from '../../../utils/parsing';
import clsx from 'clsx';

const Marketing = ({
  elem,
  column,
  row
}) => {
  const {
    color,
    icon,
    background,
    target_link_marketing,
    target_link_label,
    text,
  } = elem;
  const hoveredColor = color === 'DARK_RED' ? 'var(--quartiary-color)' : 'var(--red-color)';

  const gridInsideRenderer = () => {
    return (
      <div
        className={marketingButtonStyles.absolute}
      >
        <div className={marketingButtonStyles.rootContainer}>
          <div className={marketingButtonStyles.rootContainerChild}>
            <div className={marketingButtonStyles.itemContainer}>
              <IconContainer color="WHITE"
                icon={icon}
                size="25"
                tabIndex={-1}
                variant="full"
              />
            </div>
            <div className={marketingButtonStyles.link}>
              <p
                className={clsx(marketingButtonStyles.h3Text, marketingButtonStyles.text)}
              >
                {text}
              </p>
              <div
                className={marketingButtonStyles.margin}
              >
                <span
                  className={marketingButtonStyles.subText}
                >
                  {target_link_label}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const gridRenderer = () => {
    return (
      <>
        <div
          style={{
            paddingBottom: `calc((100% / ${column}) * (${row}))`,
            gridArea: '1 / 1 / -1 / -1'
          }}
        />
        <GatsbyImage
          alt={altNN(background?.alternativeText)}
          className={marketingButtonStyles.imgWrapper}
          image={getImage(background?.imageFile)}
        >
        </GatsbyImage>
        {gridInsideRenderer()}
      </>
    );
  };

  return (
    <PolyLink
      ariaLabel={text}
      className={marketingButtonStyles.blocPrincipal}
      style={{backgroundColor: hoveredColor}}
      target="_blank"
      url={target_link_marketing}
    >
      {gridRenderer()}
    </PolyLink>
  );
};

Marketing.propTypes = {
  column: PropTypes.number,
  elem: PropTypes.shape({
    background: PropTypes.shape({
      imageFile: PropTypes.object.isRequired,
      alternativeText: PropTypes.string,
    }),
    color: PropTypes.oneOf(['DARK_RED', 'RED']).isRequired,
    height: PropTypes.string,
    icon: PropTypes.string.isRequired,
    target_link_label: PropTypes.string.isRequired,
    target_link_marketing: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    target_link_alt: PropTypes.string,
  }),
  height: PropTypes.any,
  row: PropTypes.number,
};

export default Marketing;
